"use client";

import { useEffect } from "react";

/**
 * Rive Provider that sets up the WASM runtime according to Rive best practices
 * This should be called once at the app level before any Rive components are rendered
 */
export function RiveProvider({
  children
}) {
  useEffect(() => {
    // Set up self-hosted WASM according to Rive docs
    // https://help.rive.app/runtimes/web/self-hosting-wasm
    const setupRiveWasm = async () => {
      try {
        const {
          RuntimeLoader
        } = await import("@rive-app/react-canvas");

        // Set the self-hosted WASM URL
        // This prevents CDN requests and improves performance
        RuntimeLoader.setWasmUrl("/rive.wasm");
      } catch (error) {
        console.error("[Rive] Failed to configure self-hosted WASM:", error);
        console.error("[Rive] Falling back to CDN WASM loading");
      }
    };
    setupRiveWasm();
  }, []);
  return <>{children}</>;
}